"use strict";

/**
 * utility class working with strings
 */
var StringUtil = {

    dashToCamel:function(str){
        return str.toLowerCase().replace(/-(.)/g, function(m, g) {
                return g.toUpperCase();
        });
    },

    camelToDash:function(str) { 
        return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    },

    underscoreToCamel:function(str){
        return str.toLowerCase().replace(/_(.)/g, function(m, g) {
                return g.toUpperCase();
        });
    },

    camelToUnderscore:function(str) { 
        return str.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    },

    pad:function(number,length,c){
        var str = String(number);
        c = c || "0";
        while (str.length < length)
            str = c + str;
        return str;
    }
    
};

module.exports = StringUtil;